import { arrayToObj } from '@/utils/utils'
import i18n from '@/locales'

export const providerOptions = [
  { key: 'JumpServer', label: 'JumpServer' + i18n.t('bastionHost.title') },
]

export const providerOptionsMap = arrayToObj(providerOptions, 'key')
